module.exports = __webpack_public_path__ + "img/api.3103ce12.jpg";